<template>
  <transition name="message-fade">
    <div v-if="visible" :class="['message']">
      <img v-if="type == 'success'" class="icon" src="./svg/success.svg" alt="">
      <img v-if="type == 'error'" class="icon" src="./svg/error.svg" alt="">
      <img v-if="type == 'warning'" class="icon" src="./svg/warning.svg" alt="">
      {{ text }}
    </div>
  </transition>
</template>

<script>
export default {
  props: ['text', 'visible', 'type']
}
</script>

<style>
.message {
  position: fixed;
  top: .9em;
  left: 50%;
  transform: translate(-50%, 0);
  background-color: #fff;
  padding: 13px 20px;
  display: flex;
  align-items: center;
  border-radius: 6px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  z-index: 9999;
  font-size: 14px;
  font-weight: bold;
}
.message .icon{
  width: 20px;
  height: 20px;
  margin-right: 5px;
}

.success {
  color: #67c23a;
  background-color: #fff;
}

.warning {
  color: #e6a23c;
  background-color: #fff;
}

.error {
  color: #f56c6c;
  background-color: #fff;
}
.message-fade-enter-active,
.message-fade-leave-active {
  transition: opacity 0.5s;
}

.message-fade-enter,
.message-fade-leave-to {
  opacity: 0;
}
</style>
